/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_USER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_USER_LIST,
    //       variables: {
    //         input: {
    //           offset: args?.offset ?? 0,
    //           size: args?.size ?? 10,
    //           criteria: {
    //             ...args?.criteria,
    //             role: config?.role,
    //           },
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       console.log(`table data`, res);
    //       let _rowData = this.formatUserTable(res?.data?.getListOfUser?.data);
    //       console.log(`row data`, _rowData);
    //       return {
    //         ...config,
    //         ultUsers: _rowData,
    //         isEmpty: res?.data?.getListOfUser?.data?.length <= 0,
    //         // studentGroup: holderGroups,
    //         activePage: res?.data?.getListOfUser?.currentPage,
    //         pageSize: res?.data?.getListOfUser?.pageSize,
    //         totalCount: res?.data?.getListOfUser?.totalCount,
    //         totalPages: res?.data?.getListOfUser?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   console.log(`error in table data`, err);
    //   return {
    //     isEmpty: true,
    //   };
    // }
    let _rowData = this.formatUserTable(config?.ultUsers);
    return {
      ...config,
      ultUsers: _rowData,
      isEmpty: config?.ultUsers?.length <= 0,
      // studentGroup: holderGroups,
      activePage: config?.currentPage,
      pageSize: config?.pageSize,
      totalCount: config?.totalCount,
      totalPages: config?.totalPages,
    };
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      config?.ultUsers?.map((item: any) => {
        return {
          id: item?.id,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${item?.firstName} ${item?.lastName}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          group: item?.group,
          image: item?.img,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LLL");
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "INVITED":
          return "invited";
        case "EMAIL_VERIFIED":
          return "verified";
        case "ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
